import { List, ListIcon, ListItem, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { AboutComponent } from '@/widgets/AboutComponent';
import { RedirectToAppButton } from '@/widgets/RedirectToAppButton';
import { RequestAccessModal } from '@/widgets/RequestAccessModal';
import { CheckIcon } from '@/shared/ui';
import main3 from '/public/main-page/main-3.png';

const AutomationReviews = () => {
  const { t } = useTranslation();
  const heading = t('mainPage.automationReviews.heading');
  const featuresData = t('mainPage.automationReviews.features', {
    returnObjects: true,
  });
  const features = Array.isArray(featuresData) ? featuresData : [];

  return (
    <AboutComponent
      button={
        <>
          <List
            display='flex'
            flexDir='column'
            gap='xs'
          >
            {features.map((text) => (
              <ListItem
                key={text}
                fontSize='lg'
              >
                <ListIcon
                  as={CheckIcon}
                  color='green.500'
                />
                {text}
              </ListItem>
            ))}
          </List>
          <Stack
            direction={{ base: 'column', sm: 'row' }}
            pt={2}
            spacing={4}
            w={{ base: 'full', sm: 'auto' }}
          >
            <RedirectToAppButton
              buttonText={t('mainPage.automationReviews.startFreeButton')}
              dataLayer={{ data: { redirected_from: 'main_page_main_block' } }}
              pageName='signup'
              size='md'
            />
            <RequestAccessModal
              buttonText={t('mainPage.automationReviews.scheduleCallButton')}
              variant='outline'
            />
          </Stack>
          <Text
            fontSize='md'
            textAlign={{ base: 'center', lg: 'start' }}
          >
            {t('mainPage.automationReviews.helpText')}
          </Text>
        </>
      }
      containerProps={{ gap: '20' }}
      description={t('mainPage.automationReviews.description')}
      heading={heading}
      image={main3}
      imageAlt={heading}
      imageProps={{ isEager: true }}
    />
  );
};

export default AutomationReviews;
